import React, { useCallback, useRef, useEffect, useState } from 'react';

import { Content, Background, AnimatedDiv2, ContainerCientific } from './styles';

import CientificLibraryComponent from '../../components/CientificLibrary';
import { useSocket } from '../../hooks/Socket';


const CientificLibrary: React.FC = () => {
  const { socket } = useSocket();


  return (
    <ContainerCientific>
      <CientificLibraryComponent />
    </ContainerCientific>
  );
};
export default CientificLibrary;
